window.loadHCaptcha = function () {
    if (!window.hcaptchaLoaded) {
        window.hcaptchaLoaded = true;

        const script = document.createElement('script');
        script.src = 'https://hcaptcha.com/1/api.js?onload=onHCaptchaLoad'; // Define o callback de carregamento
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);
    }
};
